(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fate-hero-parallax"] && !Shopify.designMode) return;
  try {
    
  function initFate() {
    const slides = document.querySelectorAll('.fate-hp__slide');
    const items = document.querySelectorAll('.fate-hp__item');
    const ctas = document.querySelectorAll('.fate-hp__cta');
    if (!slides.length) return;

    const observerOptions = { threshold: 0.5 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = Array.from(slides).indexOf(entry.target);
          items.forEach(i => i.classList.remove('is-active'));
          ctas.forEach(c => c.classList.remove('is-active'));
          if(items[index]) items[index].classList.add('is-active');
          if(ctas[index]) ctas[index].classList.add('is-active');
        }
      });
    }, observerOptions);

    slides.forEach(slide => observer.observe(slide));
  }
  document.addEventListener('DOMContentLoaded', initFate);
  document.addEventListener('shopify:section:load', initFate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
